import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarState {
	mobileOpen: boolean;
	setMobileOpen: (open?: boolean) => void;
	pinnedReportsSort: 'az' | 'za' | 'newest' | 'oldest';
	setPinnedReportsSort: (sort: string) => void;
	favouritesCollapsed: boolean;
	setFavouritesCollapsed: (collapsed: boolean) => void;
	reportsOverviewFavouritesCollapsed: boolean;
	setReportsOverviewFavouritesCollapsed: (collapsed: boolean) => void;
}

export const useSidebarStore = create<SidebarState>()(
	persist(
		(set) => ({
			mobileOpen: false,
			setMobileOpen: (open: boolean) => set({ mobileOpen: open }),
			pinnedReportsSort: 'newest',
			setPinnedReportsSort: (sort: SidebarState['pinnedReportsSort']) => set({ pinnedReportsSort: sort }),
			favouritesCollapsed: false,
			setFavouritesCollapsed: (collapsed: boolean) => set({ favouritesCollapsed: collapsed }),
			reportsOverviewFavouritesCollapsed: false,
			setReportsOverviewFavouritesCollapsed: (collapsed: boolean) => set({ reportsOverviewFavouritesCollapsed: collapsed }),
		}),
		{
			name: 'sidebar',
			partialize: (state) => ({
				pinnedReportsSort: state.pinnedReportsSort,
				favouritesCollapsed: state.favouritesCollapsed,
				reportsOverviewFavouritesCollapsed: state.reportsOverviewFavouritesCollapsed,
			}),
		},
	),
);
